export const environment = {
    production: true
};
export const API_URL = "https://acc.admin.ab-connect.nl/api";
